import {PaginaLogada} from "../../componentes";
import {exibirMensagemSucesso, formatarDinheiroItl, HttpVerbo, xfetch} from "../../util";
import {useEffect, useMemo, useState} from "react";
import {useListState} from "@mantine/hooks";
import {Projeto} from "../../tipos/projeto";
import {MantineReactTable, MRT_ColumnDef, useMantineReactTable} from "mantine-react-table";
import {MRT_Localization_PT_BR} from "mantine-react-table/locales/pt-BR";
import {ActionIcon, Badge, Group, Text, Tooltip} from "@mantine/core";
import {COR} from "../../config/constantes/constantes-mantine";
import {IconArchiveOff, IconEye} from "@tabler/icons-react";
import {modals} from "@mantine/modals";

export default function ListarProjetosArquivados() {

  const [isCarregando, setIsCarregando] = useState(false)
  const [projetos, handlersProjetos] = useListState<Projeto>()

  function carregarProjetos() {
    setIsCarregando(true)
    xfetch('/projeto?arquivado=true', {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(json => {
        handlersProjetos.setState(json)
      })
      .finally(() => setIsCarregando(false))
  }

  function desarquivar(projeto: Projeto) {
    modals.openConfirmModal({
      title: 'Desarquivar Projeto',
      children: (
        <Text>
          Deseja realmente desarquivar o projeto <b>{projeto.nome}</b>?
        </Text>
      ),
      labels: {confirm: 'Desarquivar', cancel: 'Cancelar'},
      confirmProps: {color: 'red'},
      onConfirm: () => acaoDesarquivar(projeto)
    })
  }

  function acaoDesarquivar(projeto: Projeto) {
    setIsCarregando(true)
    xfetch('/projeto/desarquivar', {'projetoId': projeto?.id}, HttpVerbo.POST)
      .then(res => res.json())
      .then(json => {
        exibirMensagemSucesso("Projeto desarquivado com sucesso")
        carregarProjetos()
      })
      .finally(() => setIsCarregando(false))
  }

  const colunas = useMemo<MRT_ColumnDef<Projeto>[]>(() => [
      {
        accessorKey: 'nome',
        header: 'Nome',
        filterVariant: 'autocomplete',
        size: 300
      },
      {
        accessorKey: 'setor.nome',
        header: 'Setor',
        Cell: ({renderedCellValue, row}) => {
          if (renderedCellValue !== null) {
            return (
              <Tooltip label={row.original.setor?.sigla}>
                <Badge color={row.original.setor?.cor}>
                  {renderedCellValue}
                </Badge>
              </Tooltip>
            )
          }
          return ""
        },
        filterVariant: 'multi-select',
      },
      {
        accessorKey: 'valorTotal',
        header: 'Valor Total',
        Cell: ({cell}) =>
          formatarDinheiroItl(cell.getValue()),
        filterVariant: 'range-slider',
        filterFn: 'betweenInclusive',
        mantineFilterRangeSliderProps: {
          step: 5_000,
          label: (value) => formatarDinheiroItl(value)
        },
      },
      {
        accessorKey: 'ano',
        header: 'Ano',
        Cell: ({cell}) =>
          formatarDinheiroItl(cell.getValue()),
        filterVariant: 'range-slider',
        filterFn: 'betweenInclusive',
      },
      {
        accessorKey: 'dataInicio',
        header: 'Data Início',
        Cell: ({cell}) => {
          return cell.getValue() != null ? new Date(cell.getValue<Date>()).toLocaleDateString() : ""
        },
        filterVariant: 'date-range',
      },
      {
        accessorKey: 'dataLimite',
        header: 'Data Fim',
        Cell: ({cell}) => {
          return cell.getValue() != null ? new Date(cell.getValue<Date>()).toLocaleDateString() : ""
        },
        filterVariant: 'date-range',
      },
      {
        accessorKey: 'arquivos',
        header: 'Arquivos',
        Cell: ({row}) => {
          return row.original.arquivos?.length
        },
        filterVariant: 'date-range',
      },
      {
        accessorKey: 'metas',
        header: 'Metas',
        Cell: ({row}) => {
          return row.original.metas?.length
        },
        filterVariant: 'date-range',
      },
    ],
    []
  )

  const table = useMantineReactTable({
    columns: colunas,
    data: projetos,
    autoResetPageIndex: false,
    enableSorting: false,
    localization: MRT_Localization_PT_BR,
    initialState: {
      showGlobalFilter: true,
      columnVisibility: {
        id: false
      }
    },
    enableRowActions: true,
    positionActionsColumn: 'last',
    renderRowActions: ({row}) => (
      <Group wrap="nowrap" gap="lg">
        <Tooltip label="Alterar">
          <ActionIcon
            aria-label="Detalhes"
            color={COR.INFO}
            // onClick={() => {editarUsuario(row.original)}}
          >
            <IconEye/>
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Desarquivar">
          <ActionIcon
            aria-label="Desarquivar"
            color={COR.PERIGO}
            onClick={() => desarquivar(row.original)}>
            <IconArchiveOff/>
          </ActionIcon>
        </Tooltip>
      </Group>
    ),
  })

  useEffect(() => {
    carregarProjetos()
  }, [])

  return (
    <PaginaLogada titulo={"Listar Projetos Arquivados"} isCarregando={isCarregando}>

      <MantineReactTable table={table} />

    </PaginaLogada>
  );
}
